import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { onAttributeChoiceSearch } from "../../controller/AttributeController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { Col, Button, Row, Container, Form } from 'react-bootstrap';
import { AttributeChoiceEntity } from "../../dto/attribute/AttributeChoiceEntity";
import { ReadPageable } from "../../dto/response/ReadPageable";
import { AttributeChoiceModel } from "../../dto/attribute/AttributeChoiceModel";
import { AttributeChoiceSearch } from "../../dto/attributechoice/AttributeChoiceSearch";
import { onAttributeChoiceSubmit } from "../../controller/CategoryController";

type AttributeParams = {
    choiceId: string;
};

const AttributeChoiceDetail = () => {
    const urlParam = useParams<AttributeParams>();
  
    const navigate = useNavigate();
    const entity: AttributeChoiceEntity = {
        id: parseInt(urlParam.choiceId!)
    }
    const [choice, setChoice] = useState<AttributeChoiceModel>({
        action: 'update',
        entity: entity
    });
    const formRef = useRef<HTMLFormElement>(null);

    useEffect(() => {
        if (!AuthUtility.isUserLoggedIn()) {
            navigate("/login");
            window.location.reload();
        } else {
            attributeDetailGet();
        }
    }, [])
    
    // attribute choice update
    const attributeDetailGet = async () => {
        const search: AttributeChoiceSearch = {
            id: parseInt(urlParam.choiceId!),
            offset: 0,
            limit: 1
        }
        const attributeResponse = await onAttributeChoiceSearch(search);
        if (attributeResponse.status === 0) {
            // attribute
            var pageable: ReadPageable = attributeResponse.data;
            const attributesResponse: Array<AttributeChoiceEntity> = pageable.beans;
            var prevState = {...choice.entity};
            prevState = attributesResponse[0];
            setChoice({
                ...choice,
                entity: prevState
            });
        }
    }

    const handleReset = () => {
        if (formRef.current !== null) {
            formRef.current.reset();
        }
    };

    const attributeChoiceSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        try {
            const response = await onAttributeChoiceSubmit(choice);
            if (response !== undefined) {
                if (response.status === 0) {
                    toast.success(response.msg);
                    attributeDetailGet();
                } else {
                    toast.error(response.msg);
                    let err = Object.entries(response.errors)
                    err.map( ([key, val]) => {
                      toast.error(key + ": " + val);
                    });
                }
            }
        } catch(e: any) {
            toast.error("Амжилтгүй");
        }
        handleReset();
    }

    return (
        <Container fluid>
            <div><Toaster position="top-right"  reverseOrder={false}/></div>
            <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Атрибут choice</h3>
            <Row>
            <Form noValidate
                onSubmit={attributeChoiceSubmit}
                ref={formRef}>
                    <Row className="mb-3">
                        <Col sm={6} md={6} lg={6}>
                            <Form.Group controlId="name">
                                <Form.Label>УТГА</Form.Label>
                                <Form.Control size="sm" type="text" value={choice.entity.valueText}
                                onChange = {(event) => {
                                    const prevState: AttributeChoiceEntity = {...choice.entity};
                                    prevState.valueText = event.target.value;
                                    setChoice({
                                        ...choice,
                                        entity: prevState
                                    });
                                }}/>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col sm={6} md={6} lg={6}>
                            <Form.Group controlId="weight">
                                <Form.Label>ЖИН</Form.Label>
                                <Form.Control size="sm" type="number" step="0.01" value={choice.entity.defaultWeightGrams}
                                onChange = {(event) => {
                                    const prevState: AttributeChoiceEntity = {...choice.entity};
                                    prevState.defaultWeightGrams = parseInt(event.target.value);
                                    setChoice({
                                        ...choice,
                                        entity: prevState
                                    });
                                }}/>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col sm={3} md={3} lg={3}>
                            <Button size="sm" type="submit">
                                Хадгалах
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Row>
        </Container>
    )
}

export default AttributeChoiceDetail;